module.exports = [
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 12.4
  },
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 11.33
  },
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 8.93
  },
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 6.3
  },
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 5.23
  },
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 4.47
  },
  {
    "COD": "HIV",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 3.55
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 5.17
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 4.7
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 3.97
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 2.97
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 2.23
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 1.9
  },
  {
    "COD": "HIV",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 1.55
  }
]
